<div *ngIf="article" class="container-article has-background-white">
    <a name="{{article.articleNumber}}"></a>
    <div class="container-image">
        <a
        [routerLink]="['/sortiment', 'details', article.articleNumber, articleTemplateService.getParamForUrl(article.name)]"
                (click)="articleTemplateService.goToArticle(article)">
            <img *ngIf="article.images && article.images[0]" alt="{{article.name}}" src="{{resourceUrl + article.images[0].thumbnails.small}}" class="img">
            <fa-icon *ngIf="!article.images || article.images.length == 0" [icon]="faImages" [attr.aria-label]="article.name"  class="is-size-1 img pb-6 m-auto"></fa-icon>

        </a>
        <iw-shop-article-notification *ngIf="isNotification"
                                      [notifications]="article.notifications"></iw-shop-article-notification>
    </div>
    <a
            [routerLink]="['/sortiment', 'details', article.articleNumber, articleTemplateService.getParamForUrl(article.name)]"
            (click)="articleTemplateService.goToArticle(article)"
            class="name mt-2 is-block has-text-weight-semibold is-size-6">
        <span *ngIf="getRelatedArticles(article.relatedArticleGroup).length > 0">{{ article.relatedArticleGroup }} </span>
        <span *ngIf="getRelatedArticles(article.relatedArticleGroup).length == 0">{{ article.name }} </span>
    </a>
    <div class="is-flex-tablet is-align-items-flex-end">
        <div>
            <p class="is-size-7">Art.-Nr.: {{article.articleNumber}}</p>
        </div>

        <div class="is-flex-grow-1 has-text-right">
               <iw-shop-article-price [article]="article"></iw-shop-article-price>
        </div>
    </div>
    <hr class="my-2"/>

    <div class="my-2" *ngIf="getRelatedArticles(article.relatedArticleGroup).length <= 1" >
      <span *ngIf="article.unit != 0">
          <span class="quantity">{{article.quantity}}</span>
          <span class="quantity-addition" *ngIf="(article.quantityAddition?.length ?? 0) > 0">&nbsp;{{article.quantityAddition}}</span>
          <span class="quantity-x-unit">&nbsp;x&nbsp;</span>
          <span class="unit">{{NumberFormat(article.unit)}}</span>
         </span>
        <span class="unit-of-measurement" *ngIf="(article.unitOfMeasurement?.length ?? 0) > 0">{{article.unitOfMeasurement}}</span>
        <span class="unit-addition" *ngIf="(article.unitAddition?.length ?? 0) > 0">&nbsp;{{article.unitAddition}}</span>
        <span  class="package-type" *ngIf="article.packageType">&nbsp;{{article.packageType}}</span><br *ngIf="article.unitType">
        <span  class="unit-type" *ngIf="article.unitType">{{article.unitType}}</span>

    </div>
    <div *ngIf="getRelatedArticles(article.relatedArticleGroup).length > 1"  class="my-2 control has-icons-left">
        <div class="select">
            <select (change)="setArticle($any($event).target.value)" [attr.aria-label]="'Gebindeauswahl '+ article.name">
                <option [value]="article.articleNumber" selected>
                    <ng-container *ngIf="article.unit != 0">{{article.quantity}} {{article.quantityAddition}} x {{NumberFormat(article.unit)}}</ng-container>
                    <ng-container *ngIf="(article.unitOfMeasurement?.length ?? 0) > 0">{{article.unitOfMeasurement}} </ng-container>
                    <ng-container *ngIf="(article.unitAddition?.length ?? 0) > 0">{{article.unitAddition}} </ng-container>
                    <ng-container *ngIf="article.packageType" class="is-uppercase">{{article.packageType}} </ng-container>
                </option>
                <ng-container *ngFor="let a of getRelatedArticles(article.relatedArticleGroup)">
                    <option [value]="a.articleNumber"  *ngIf="article.articleNumber!==a.articleNumber">
                        <ng-container *ngIf="a.unit != 0">{{a.quantity}} {{a.quantityAddition}} x {{NumberFormat(a.unit)}}</ng-container>
                        <ng-container *ngIf="(a.unitOfMeasurement?.length ?? 0) > 0">{{a.unitOfMeasurement}} </ng-container>
                        <ng-container *ngIf="(a.unitAddition?.length ?? 0) > 0">{{a.unitAddition}} </ng-container>
                        <ng-container *ngIf="a.packageType" class="is-uppercase">{{a.packageType}} </ng-container>
                    </option>
                </ng-container>

            </select>
        </div>
        <span class="icon is-left">
    <fa-icon [icon]="faArrowsUpDown" role="img" aria-label="Nach oben springen"></fa-icon>
  </span>
    </div>


    <div class="is-size-7">
        <div>
            @if (userService.hasLoggedInUserAccess({ type: 'prices', customerId: (customer$ | async)?.id ?? '' })) {

            <span *ngIf="(customer$ | async)?.priceMode == 'net'">Exkl.</span>
            <span *ngIf="(customer$ | async)?.priceMode != 'net'">Inkl.</span>
            {{article.taxRate}} % MwSt. <span class="link-delivery-costs" >, zzgl. <a routerLink="/lieferkosten">Lieferkosten</a></span> <span
                *ngIf="article.bestPrice && article.bestPrice.netFee && article.bestPrice.netFee > 0 && (customer$ | async)?.priceMode == 'net'"> und Gebühren </span>
                <span *ngIf="article.bestPrice?.netDeposit!==0 ">
              + Pfand {{ articleService.getPrice(article.bestPrice?.netDeposit || 0, configService.getDepositTaxRate(), (customer$ | async)?.priceMode || 'gross') }}
            </span>
            }
            <div class="availability"
                 [style.color]="this.articleService.getAvailabilityColor(article.inventory || 0, article.availability)">
                {{this.articleService.getAvailability(article.inventory || 0, article.availability)}}
            </div>

            <!--        <span *ngIf="article.allergenIngredients" class="legal">
                    <b>Allergene: </b>
                    <b *ngFor="let item of article.allergenIngredients">{{item}}</b>
                  </span>
                    <span *ngIf="article.additives" class="legal" >
                    Zusatzstoffe: <span *ngFor="let item of article.additives">{{item}}</span>
                  </span>
                    <span *ngIf="article.alcoholicStrength" class="legal" >
                    Alkoholgehalt: {{article.alcoholicStrength}}%
                  </span>
                    <span *ngIf="article.caffeine" class="legal" >
                    Koffeingehalt: {{article.caffeine}}
                  </span>-->
            <div class="is-flex">
                <a
                        [routerLink]="['/sortiment', 'details', article.articleNumber, articleTemplateService.getParamForUrl(article.name)]"
                        (click)="articleTemplateService.goToArticle(article)"
                        class="link-product-details-lmiv mt-2 is-block is-size-7">Produktdetails <span class="lmiv">/ LMIV</span></a>
                <div class="is-flex-grow-1 has-text-right">
                    <iw-shop-article-favorite-button
                            [articleNumber]="article.articleNumber"></iw-shop-article-favorite-button>
                </div>
            </div>


        </div>

    </div>
    <div class="container-cart">
        <hr class="my-2"/>
        <iw-shop-article-cart-button [article]="article" [showOverlayPanel]="true"></iw-shop-article-cart-button>
    </div>
</div>
